export const documentRoutes = [
  {
    path: $localize`:@@/privacy:privacy`,
    documentUrl:
      'https://skillz.blob.core.windows.net/docs/privacy_verklaring.pdf',
  },
  {
    path: $localize`:@@/terms-and-conditions:terms-and-conditions`,
    documentUrl:
      'https://skillz.blob.core.windows.net/docs/algemene_voorwaarden_skillz.pdf',
  },
  {
    path: $localize`:@@/terms-of-use:terms-of-use`,
    documentUrl:
      'https://skillz.blob.core.windows.net/docs/gebruiks_voorwaarden.pdf',
  },
  {
    path: $localize`:@@/integrity:integrity`,
    documentUrl:
      'https://skillz.blob.core.windows.net/docs/2024_Integriteitsbeleid_Skillz.pdf',
  },
].map(({ path, documentUrl }) => ({
  path,
  resolve: {
    documentUrl: () => documentUrl,
  },
  loadComponent: () =>
    import('./legal-document-viewer/legal-document-viewer.component'),
}));
